import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Container } from '@/components/ui/Container';
import { StatusIndicator } from '@/components/ui/StatusIndicator';
import { NAV_ITEMS, CONTACT_INFO } from '@/utils/constants';
import { useHealthCheck } from '@/hooks/useHealthCheck';
import logo from '@/assets/logo.png';

export const Footer: FC = () => {
  const { isHealthy, isChecking } = useHealthCheck();
  const enableHealthCheck = import.meta.env.VITE_ENABLE_HEALTH_CHECK === 'true';

  return (
    <footer className="bg-apple-light-gray border-t border-apple-separator">
      <Container>
        {/* Main Grid */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-flex items-center space-x-2 mb-4">
              <img src={logo} alt="白茆AI" className="w-7 h-7 rounded-[7px]" />
              <span
                className="text-[17px] font-semibold text-apple-dark"
                style={{ letterSpacing: '-0.015em' }}
              >
                白茆AI
              </span>
            </Link>
            <p className="text-[15px] text-apple-gray leading-relaxed max-w-xs">
              基于 Claude 技术的 AI 编程助手，为开发者提供智能代码生成、审查和优化服务。
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs font-semibold text-apple-gray uppercase tracking-widest mb-4">
              产品
            </h3>
            <ul className="space-y-2.5">
              {NAV_ITEMS.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-[15px] text-apple-gray hover:text-apple-dark transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs font-semibold text-apple-gray uppercase tracking-widest mb-4">
              联系
            </h3>
            <ul className="space-y-3">
              <li>
                <span className="block text-xs text-apple-gray mb-0.5">商务邮箱</span>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="text-[15px] text-apple-dark hover:text-apple-blue transition-colors"
                >
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li>
                <span className="block text-xs text-apple-gray mb-0.5">工作时间</span>
                <span className="text-[15px] text-apple-dark">{CONTACT_INFO.workingHours}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-apple-separator py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <p className="text-sm text-apple-gray">
              Copyright © 2025 白茆AI. All rights reserved.
            </p>
            {enableHealthCheck && (
              <StatusIndicator
                status={isChecking ? 'checking' : (isHealthy ? 'healthy' : 'unhealthy')}
                showText
              />
            )}
          </div>

          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-apple-gray hover:text-apple-dark transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-sm text-apple-gray hover:text-apple-dark transition-colors">
              服务条款
            </a>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-apple-gray hover:text-apple-dark transition-colors"
            >
              浙ICP备2025184466号
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};
